import { getLocale } from "../runtime";

const da_itemsnotreserved = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `* Produkterne er ikke reserveret.`
};

const en_itemsnotreserved = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `* Products are not reserved.`
};

const es_itemsnotreserved = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `* Los productos no están reservados.`
};

const fi_itemsnotreserved = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `* Tuotteita ei ole varattu.`
};

const nb_itemsnotreserved = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `* Produktene er ikke reservert.`
};

const sv_itemsnotreserved = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `* Produkterna är inte reserverade.`
};

const itemsnotreserved = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_itemsnotreserved(inputs)
	if (locale === "en") return en_itemsnotreserved(inputs)
	if (locale === "es") return es_itemsnotreserved(inputs)
	if (locale === "fi") return fi_itemsnotreserved(inputs)
	if (locale === "nb") return nb_itemsnotreserved(inputs)
	if (locale === "sv") return sv_itemsnotreserved(inputs)
	return "itemsNotReserved";
};

export { itemsnotreserved as "itemsNotReserved" };